module.exports = __webpack_public_path__ + "img/boxstop-hero-illustration-01.95a11744.png";